import { Link } from "react-router-dom";
import { ReactComponent as Logo } from "../../../assets/svgs/landing-mobio-logo.svg";
import { ReactComponent as PCMock } from "../../../assets/svgs/landing-mobio-pc-mock.svg";
import "./landing.css";

const landing = () => {
  return (
    <div className="landing-box">
      <Logo className="landing-logo" />
      <div className="landing-content">
        <div className="landing-textbox">
          <h2 className="landing-main-heading">
            Play A Key Role In Delivering Exceptional Service And Driving
            Operational Excellence
          </h2>
          <p className="landing-description">
            Be at the heart of our operations, ensuring efficient and timely
            coordination between drivers and clients. Optimize routes, manage
            schedules, and handle real-time adjustments to keep everything
            running smoothly
          </p>
        </div>
        <div className="landing-buttons-wrapper">
          <Link className="landing-button" to={"/sign-up"}>
            Begin you journey
          </Link>
          <Link className="landing-privacy-button" to="/privacy-policy">Privacy Policy</Link>
        </div>
      </div>
      <PCMock className="landing-laptop-img" />
      <footer className="landing-footer">
        Copyright © 2020-2024 All Rights Reserved by Mobio Technologies B.V.
      </footer>
    </div>
  );
};

export default landing;
